export default {
	'position-single': '# {position}',
	'position-range': '# {positionStart} — {positionEnd}',
};
